/**
 * Created by Sebastian on 23.11.2015.
 */
import angular from "angular";
import ImportCtrl from "./import.controller";
import importStateConfiguration from "./import.route";
import ImportPackagesCtrl from "./states/package/package.controller";
import ExcelCtrl from "./states/excel/excel.controller";
import "angular-ui-router";
import "../../common/ui-elements/directives/sbFileInput/sb_file_input.directive";
import "common/services/services";

export default angular
    .module("sbApp.import", [
        "ngMaterial",
        "ngCookies",
        "ui.router",
        "sbApp.sbFileInput",
        "sbApp.intercom",
        "sbApp.services",
        "sbApp.configs",
    ])
    .config(importStateConfiguration)
    .controller("ImportCtrl", ImportCtrl)
    .controller("ImportPackagesCtrl", ImportPackagesCtrl)
    .controller("ExcelCtrl", ExcelCtrl);
